'use client';

import React__default from 'react';
import { EMPTY_COMPANY_IMAGE } from '../CompaniesYouWillLove/constants.js';
import { ELanguage } from '../Utils/constants.js';
import { buildCompanyUrl } from '../Utils/urlBuilder.js';
import { CompanyInfoWrapper, CompanyInfoLogo, CompanyInfoContentSection, CompanyInfoDescription, CompanyInfoJobCount } from './CompanyInfo.css.js';
import translations from './translation.js';
import TrustedCompanyName from '../TrustedCompanyName/index.js';

var CompanyInfo = function (props) {
    var langCode = props.langCode, companyInfo = props.companyInfo;
    var followCount = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) || 0;
    var companyUrl = buildCompanyUrl({
        companyId: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0,
        companySlug: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) || '',
        langCode: langCode
    });
    var t = function (text) {
        if (langCode === ELanguage.EN) {
            return text;
        }
        else {
            return translations[text];
        }
    };
    return (React__default.createElement(CompanyInfoWrapper, { className: 'view_job_item' },
        React__default.createElement(CompanyInfoLogo, { href: companyUrl },
            React__default.createElement("img", { src: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL) || EMPTY_COMPANY_IMAGE, alt: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName })),
        React__default.createElement(CompanyInfoContentSection, { isShowFollow: false },
            React__default.createElement(TrustedCompanyName, { name: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName, href: companyUrl, style: { marginBottom: 4 }, isTrusted: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 1, tooltip: t('Trusted company') }),
            React__default.createElement(CompanyInfoDescription, null,
                React__default.createElement("span", null,
                    followCount,
                    ' ',
                    companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) > 1
                        ? t('followers')
                        : t('follower'))),
            companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) > 0 ? (React__default.createElement(CompanyInfoJobCount, null, companyInfo === null || companyInfo === void 0 ? void 0 :
                companyInfo.onlineJobCount,
                ' ',
                (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) > 1 ? t('opening jobs') : t('opening job'))) : null)));
};

export { CompanyInfo as default };
//# sourceMappingURL=index.js.map
